<ng-container *ngIf="readonly else editMode">
  <ng-container *ngIf="enableAddressForNativeLanguage else disableAddressForNativeLanguage">
    <div class="address-readonly">
      {{ getDisplayAddressWithLabel() | replaceNullWith:'-' }}
    </div>
    <div class="p-grid">
      <div class="p-col-12 p-field">
        <div class="p-field-label" *ngIf="label">
          <label>{{ label | translate }}({{ 'SigvLibrary.NativeLanguage' | translate }})</label>
        </div>
        <div class="address-readonly">
          {{ getDisplayNativeAddress() | replaceNullWith:'-' }}
        </div>
      </div>
    </div>
  </ng-container>
  <ng-template #disableAddressForNativeLanguage>
    <div class="address-readonly">
      {{ getDisplayAddress() | replaceNullWith:'-' }}
    </div>
  </ng-template>
</ng-container>
<ng-template #editMode>
  <div class="p-grid">
    <div [ngClass]="[getColSizeClass(1), 'p-field']">
      <p-dropdown #level1DDL sigvDropdownSetting [(ngModel)]="model.level1" [options]="displayLevel1Options"
        [class.invalid]="checkIsLevelInvalid('addressLevel1Requied')" placeholder=" {{ 'SigvLibrary.StatePlaceholder' | translate }}"
        appendTo="body" [showClear]="true" class="addr-level-01"
        (ngModelChange)="onLevel1Change()"></p-dropdown>
      <ng-container *ngIf="control?.invalid && (control?.dirty || control?.touched)">
        <small *ngIf="control?.errors?.addressLevel1Requied" class="p-error">
          {{ 'SigvLibrary.MustNotBeBlank' | translate:{field: ''} }}
        </small>
      </ng-container>
    </div>
    <div *ngIf="checkIsLevelAvalaible(2)" [ngClass]="[getColSizeClass(1), 'p-field']">
      <p-dropdown #level2DDL sigvDropdownSetting [(ngModel)]="model.level2" [options]="displayLevel2Options" [disabled]="!level1DDL.value"
        [class.invalid]="checkIsLevelInvalid('addressLevel2Requied')" placeholder=" {{ 'SigvLibrary.CityPlaceholder' | translate }}"
        appendTo="body" [showClear]="true" class="addr-level-02"
        (ngModelChange)="onLevel2Change()"></p-dropdown>
      <ng-container *ngIf="control?.invalid && (control?.dirty || control?.touched)">
        <small *ngIf="control?.errors?.addressLevel2Requied" class="p-error">
          {{ 'SigvLibrary.MustNotBeBlank' | translate:{field: ''} }}
        </small>
      </ng-container>
    </div>
    <div *ngIf="checkIsLevelAvalaible(3)" [ngClass]="[getColSizeClass(1), 'p-field']">
      <p-dropdown #level3DDL sigvDropdownSetting [(ngModel)]="model.level3" [options]="displayLevel3Options" [disabled]="!level2DDL?.value"
        [class.invalid]="checkIsLevelInvalid('addressLevel3Requied')" placeholder=" {{ 'SigvLibrary.PleaseSelect' | translate }}"
        appendTo="body" [showClear]="true" class="addr-level-03"
        (ngModelChange)="onLevel3Change()"></p-dropdown>
      <ng-container *ngIf="control?.invalid && (control?.dirty || control?.touched)">
        <small *ngIf="control?.errors?.addressLevel3Requied" class="p-error">
          {{ 'SigvLibrary.MustNotBeBlank' | translate:{field: ''} }}
        </small>
      </ng-container>
    </div>
    <div *ngIf="checkIsLevelAvalaible(4)" [ngClass]="[getColSizeClass(1), 'p-field']">
      <p-dropdown #level4DDL sigvDropdownSetting [(ngModel)]="model.level4" [options]="displayLevel4Options" [disabled]="!level3DDL?.value"
        [class.invalid]="checkIsLevelInvalid('addressLevel4Requied')" placeholder=" {{ 'SigvLibrary.PleaseSelect' | translate }}"
        appendTo="body" [showClear]="true" class="addr-level-04"
        (ngModelChange)="onLevel4Change()"></p-dropdown>
      <ng-container *ngIf="control?.invalid && (control?.dirty || control?.touched)">
        <small *ngIf="control?.errors?.addressLevel4Requied" class="p-error">
          {{ 'SigvLibrary.MustNotBeBlank' | translate:{field: ''} }}
        </small>
      </ng-container>
    </div>
  </div>
  <div class="p-grid">
    <div *ngIf="enablePostcode" [ngClass]="[getColSizeClass(1), 'p-field']">
      <p-dropdown #postcodeDDL sigvDropdownSetting [(ngModel)]="model.postcode" [options]="postcodeOptions" [disabled]="disablePostcodeDDLFunc()"
        [class.invalid]="checkIsLevelInvalid('addressPostcodeRequied')" placeholder=" {{ 'SigvLibrary.PostcodePlaceholder' | translate }}"
        appendTo="body" [showClear]="true" class="addr-postcode"
        (ngModelChange)="onPostcodeChange()"></p-dropdown>
      <ng-container *ngIf="control?.invalid && (control?.dirty || control?.touched)">
        <small *ngIf="control?.errors?.addressPostcodeRequied" class="p-error">
          {{ 'SigvLibrary.MustNotBeBlank' | translate:{field: ''} }}
        </small>
      </ng-container>
    </div>
    <div [ngClass]="[getColSizeClass(enablePostcode ? 3 : 4), 'p-field', 'p-fluid']">
      <input #level5Input pInputText [(ngModel)]="model.level5" placeholder=" {{ 'SigvLibrary.UnitPlaceholder' | translate }}"
        [class.invalid]="checkIsLevelInvalid('addressLevel5Requied')" class="addr-level-05"
        (ngModelChange)="onLevel5Change()" />
      <ng-container *ngIf="control?.invalid && (control?.dirty || control?.touched)">
        <small *ngIf="control?.errors?.addressLevel5Requied" class="p-error">
          {{ 'SigvLibrary.MustNotBeBlank' | translate:{field: ''} }}
        </small>
      </ng-container>
    </div>
  </div>
  <div *ngIf="enableAddressForNativeLanguage" class="p-grid">
    <div class="p-col-12" *ngIf="label">
      <div class="p-field-label">
        <label>{{ label | translate }}({{ 'SigvLibrary.NativeLanguage' | translate }})</label>
      </div>
    </div>
    <div [ngClass]="[getColSizeClass(2), 'p-field p-fluid']">
      <input #nativeInput pInputText [(ngModel)]="model.native" placeholder=" {{ 'SigvLibrary.UnitPlaceholder' | translate }}"
      [class.invalid]="checkIsLevelInvalid('addressNativeRequied')" class="addr-native"
      (ngModelChange)="onNativeAddrChange()"/>
      <ng-container *ngIf="control?.invalid && (control?.dirty || control?.touched)">
        <small *ngIf="control?.errors?.addressNativeRequied" class="p-error">
          {{ 'SigvLibrary.MustNotBeBlank' | translate:{field: ''} }}
        </small>
      </ng-container>
    </div>
    <div [ngClass]="[getColSizeClass(2), 'p-field p-fluid']" style="line-height: 31px">
      {{ getDisplayNativeAddressOptions() | replaceNullWith:'-'  }}
    </div>
  </div>
</ng-template>
